module.exports = __webpack_public_path__ + "static/media/icon_talk.19fec0ba.svg";